// extracted by mini-css-extract-plugin
export var callCard = "_lq-0";
export var callMessageButton = "_lq-1";
export var helpIcon = "_lq-3";
export var helpIconContainer = "_lq-4";
export var verticalDivider = "_lq-2";